<script setup>
import { computed } from "vue";
import { Doughnut } from "vue-chartjs";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const props = defineProps({
  labels: {
    type: Array,
    default: () => [],
  },
  values: {
    type: Array,
    default: () => [],
  },
});

const palette = [
  "rgba(14, 116, 144, 0.82)",
  "rgba(16, 185, 129, 0.78)",
  "rgba(99, 102, 241, 0.75)",
  "rgba(245, 158, 11, 0.75)",
  "rgba(244, 63, 94, 0.72)",
  "rgba(20, 184, 166, 0.72)",
  "rgba(148, 163, 184, 0.82)",
];

const chartData = computed(() => ({
  labels: props.labels,
  datasets: [
    {
      data: props.values,
      backgroundColor: props.values.map((_, i) => palette[i % palette.length]),
      borderColor: "rgba(255,255,255,0.15)",
      borderWidth: 1,
      hoverOffset: 6,
    },
  ],
}));

const chartOptions = computed(() => ({
  responsive: true,
  maintainAspectRatio: false,
  cutout: "62%",
  plugins: {
    legend: {
      display: true,
      position: "bottom",
      labels: {
        color: "#64748b",
        boxWidth: 12,
      },
    },
    tooltip: {
      callbacks: {
        label: (context) => `${context.label}: ${context.parsed ?? 0} jobs`,
      },
    },
  },
}));
</script>

<template>
  <div class="w-full">
    <Doughnut :data="chartData" :options="chartOptions" class="h-64" />
  </div>
</template>
